import { Alert, Typography } from "antd"
import React from "react"

const { Text } = Typography

export function PrivacySettingsFormSection() {
  return (
    <Alert
      type="info"
      showIcon
      description={
        <Text>
          By using our services, you agree to our{" "}
          <Typography.Link
            href={import.meta.env.VITE_APP_PRIVACY_POLICY}
            target="_blank"
          >
            Privacy Policy
          </Typography.Link>{" "}
          and{" "}
          <Typography.Link
            href={import.meta.env.VITE_APP_TERMS_AND_CONDITIONS}
            target="_blank"
          >
            Terms and Conditions
          </Typography.Link>
        </Text>
      }
    />
  )
}
